import type { Observable } from 'rxjs';

import apiService from '../api';
import type { ApiService } from '../api';
import uploadService from '../upload';
import type { IChargebackApi } from './types';

class LegacyApi implements IChargebackApi {
  constructor(private apiService: ApiService) {}

  public async uploadChargebackFile(file: File, invoiceId: number): Promise<void> {
    await uploadService.uploadFile(file, 'prova_acesso', null, null, invoiceId);
  }
  public loadChargebacksFiles(invoiceId: number): Observable<any> {
    return this.apiService.get(`/reports/chargebacks/${invoiceId}/files`, {});
  }
  public removeChargebackFile(invoiceId: number, fileId: number): Observable<void> {
    return this.apiService.delete(`/reports/chargebacks/${invoiceId}/files/${fileId}`);
  }
}
const legacyApi = new LegacyApi(apiService);
export default legacyApi;
